import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import EmojiPickerButton from '../../../../../components/EmojiInput';
import MessageInputContext from '../../../../context/MessageInputContext';
import ChatChannelContext from '../../../../context/ChatChannelContext';
import FileAttachmentButton from '../FileAttachmentButton';

import {
  Container,
  StyledMicIcon,
} from './styles';

const InputExtras = ({
  onEmojiChange,
  onAddAttachments,
  isEditMessage,
  isDisabled,
  verticalAlign,
  hideVoiceRecording,
  hideAttachments,
}) => {
  const {
    startVoiceRecording,
  } = useContext(MessageInputContext);

  const { coachDoc } = useContext(ChatChannelContext);

  return (
    <Container $isDisabled={isDisabled} $alignment={verticalAlign}>
      {!isEditMessage && !hideAttachments && (
        <FileAttachmentButton isDisabled={isDisabled} onFileUpload={onAddAttachments} />
      )}
      {!isEditMessage && !hideVoiceRecording && (
        <StyledMicIcon onClick={() => (!isDisabled && startVoiceRecording())} />
      )}
      <EmojiPickerButton
        isDisabled={isDisabled}
        onChange={onEmojiChange}
        isEditMessage={isEditMessage}
        coachDoc={coachDoc}
      />
    </Container>
  );
};

InputExtras.propTypes = {
  onAddAttachments: PropTypes.func.isRequired,
  onEmojiChange: PropTypes.func.isRequired,
  hideVoiceRecording: PropTypes.bool.isRequired,
  isEditMessage: PropTypes.bool,
  isDisabled: PropTypes.bool,
  verticalAlign: PropTypes.string,
  hideAttachments: PropTypes.bool,
};

InputExtras.defaultProps = {
  isEditMessage: false,
  isDisabled: false,
  verticalAlign: 'center',
  hideAttachments: false,
};

export default InputExtras;
